import type { ReactNode } from "react";

import { MenuItem } from "@skilitics/designer-ui-components";
import type { SlotId } from "@skilitics/nautilus-core-designer-data";

import type { NodeSelectionCriteria } from "../../../library";
import { useBrowseTemplates } from "../../templates";

interface Props {
  criteria: NodeSelectionCriteria;
  slotId: SlotId;
  children: ReactNode;
}

export const BrowseTemplatesAndAddToSlotMenuItem = ({ slotId, criteria, children }: Props) => {
  const handleBrowse = useBrowseTemplates({ target: { slotId }, criteria });

  return <MenuItem onClick={handleBrowse}>{children}</MenuItem>;
};
